(function($) {
	
	if ( $(window).width() < 560 ) {

		$('.benefits.wp-block-columns').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			dots: true
		});
	} 

})(jQuery);